import { FunctionComponent, useMemo } from 'react';
import styles from './CustomerDetailsLink.module.scss';

import { Field } from '@progress/kendo-react-form';
import defIcon from '../../../../assets/link_icon.svg';
import {ICustomerLink} from "../../../../model";
import {FormInput, FormTextArea, requiredValidator, TextFormField, urlValidator} from "../../../common";


interface IProps {
  index: number;
  customerLink: ICustomerLink;
  edit?: boolean;
}

const CustomerDetailsLink: FunctionComponent<IProps> = ({ customerLink, index, edit }) => {
  const editContent = useMemo(
    () => (
      <>
        <div className={styles.panel}>
          <div className={styles.leftPanel}>
            <Field
              required={true}
              validator={urlValidator}
              name={`customerLinks[${index}].url`}
              label={'URL'}
              component={edit ? FormInput : TextFormField}
              maxLength={2048}
              type='url'
            />
          </div>
          <div className={styles.rightPanel}>
            <Field
              required={true}
              name={`customerLinks[${index}].title`}
              validator={requiredValidator}
              label={'Name'}
              maxLength={256}
              component={edit ? FormInput : TextFormField}
            />
          </div>
        </div>
        <div className={styles.panel}>
          <Field
            className={styles.description}
            name={`customerLinks[${index}].description`}
            label={'Description'}
            rows={5}
            maxLength={512}
            component={edit ? FormTextArea : TextFormField}
          />
        </div>
      </>
    ),
    [edit, index],
  );

  const content = useMemo(() => {
    return (
      <div className={styles.link}>
        <a href={customerLink.url ? customerLink.url : ''} target='_blank' rel='noreferrer'>
          <img src={defIcon} alt={customerLink.description} />
          <div className={styles.delimiter}></div>
          <div className={styles.titleDesc}>
            <span className={styles.title}>{customerLink.title}</span>
            <span className={styles.desc}>{customerLink.description}</span>
          </div>
        </a>
      </div>
    );
  }, [customerLink.description, customerLink.title, customerLink.url]);

  return edit ? editContent : content;
};

export default CustomerDetailsLink;
